import { Component, ElementRef, OnInit } from '@angular/core';
import { UserData } from 'src/app/models/userData.model';
import { Router } from '@angular/router';
import { LoginService } from 'src/app/services/login.service';
import { environment } from 'src/environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { SharedDataService } from 'src/app/services/sharedDataService.service';

@Component({
  selector: 'app-my-account',
  templateUrl: './my-account.component.html',
  styleUrls: ['./my-account.component.less']
})
export class MyAccountComponent implements OnInit {
  userData: UserData | undefined;
  ch3Data: any = {};
  soldtoList: any [] = [];
  isDealerPortal: boolean = false;
  pagination = {
    total: 10,
    pageIndex: 1,
    pageSize: 10,
  };
  roleList: any [] = []
 
  singleKeyIdURI: string = `${environment.singleKeyIdToprofile}/myprofile/`
  constructor(
    private loginService:LoginService,
    private router: Router, 
    private translate:TranslateService,
    private sharedData: SharedDataService
  ) {
    this.sharedData.currentData.subscribe(data => {
      this.isDealerPortal = data.isDealerPortal;
    });
  }
  get columns(): any[] {
    return [
      { key: 'customerCode', name: this.translate.instant('SOLD_TO_NO'), visible: true,  width: '10%' },
      { key: 'customerName', name: this.translate.instant('SOLD_TO_FULL_NAME'), visible: true,  width: '15%' },
      { key: 'ch3', name: this.translate.instant('CH3'), visible: true,  width: '5%' },
      { key: 'salesArea', name:this.translate.instant('SALES_AREA'), visible: true, width: '10%'},
      // { key: 'defaultShipCode', name: this.translate.instant('SHIP_TO_NO'), visible: true, width: '7%' },
      // { key: 'defaultShipName', name: this.translate.instant('SHIP_TO_NAME'), visible: true, width: '10%' },
      { key: 'defaultPayerCode', name: this.translate.instant('PAYER_NO'), visible: true, width: '10%' },
      { key: 'defaultPayerName', name: this.translate.instant('PAYER_NAME'), visible: true, width: '15%' },
      { key: 'defaultBillCode', name: this.translate.instant('BILL_TO_NO'), visible: true, width: '10%' },
      { key: 'defaultBillName', name: this.translate.instant('BILL_TO_NAME'), visible: true,  width: '15%' },
      // { key: 'salesEmployeeCode', name: this.translate.instant('SALES_EMPLOYEE'), visible: true,  width: '12%' },
      { key: 'operate', name: this.translate.instant('OPERATIONS'), visible: true,  width: '10%' },
    ];

  }
  

  ngOnInit(): void {
    this.loginService.userData$.subscribe((userData: any) => {
      this.userData = userData;
      this.roleList = userData?.queryUserPageInfoResDTO?.roles || []
      this.getSoldToList()
    })
  }


  // get sold to list 
  getSoldToList(): void {
    let params = {  
      pageNum: this.pagination.pageIndex,
      pageSize: this.pagination.pageSize,
    };
    this.loginService.getSoldToList(params).subscribe(res => {
      this.ch3Data =  { ...res.data, customerRelationVOList: []}
      this.soldtoList = res.data?.customerRelationVOList?.records || []
      this.pagination.total = res.data?.customerRelationVOList?.total || 0;
    })
  }
  // navigate to sold to detail
  navigateToDetail(data: any): void {
    const country = localStorage.getItem("country");
    this.router.navigate([`${country}/myAccount/sold-to-detail`, { 
      customerCode: data.customerCode, 
      ch3Name: data?.ch3Name || '', 
      soldToNo: data?.customerCode || '',
      soldToName: data?.customerName || '',
      salesArea: `${data.salesOrganization}_${data.distributionChannel}_${data.division}`,
     }]);
  }

  pageIndexChange(pageIndex: number) {
    this.pagination.pageIndex = pageIndex;
    this.getSoldToList();
  }


  // modify password
  handleChangePassword(): void {
    let client_id = environment.clientID;
    let redirect_uri = environment.changePasswordReturnUrl;
    let singlekeyIdUrl = environment.singleKeyIdToprofile;
    const url = `${singlekeyIdUrl}/auth/change-password?clientId=${client_id}&returnUrl=${redirect_uri}`
    window.open(url, '_blank');
  }
  // modify email
  handleChangeEmail(): void {
    let client_id = environment.clientID;
    let redirect_uri = environment.redirectUrl;
    let singlekeyIdUrl = environment.singleKeyIdToprofile;
    const url = `${singlekeyIdUrl}/auth/change-account?clientId=${client_id}&changeType=email&returnUrl=${redirect_uri}`
    window.open(url, '_blank');
  }
  // modify phone number
  handleChangePhoneNo(): void {
    let client_id = environment.clientID;
    let redirect_uri = environment.redirectUrl;
    let singlekeyIdUrl = environment.singleKeyIdToprofile;
    const url = `${singlekeyIdUrl}/auth/change-account?clientId=${client_id}&changeType=mobile&returnUrl=${redirect_uri}`
    window.open(url, '_blank');
  }

  // delete account
  handleDeleteAccount(): void {
    let client_id = environment.clientID;
    let redirect_uri = environment.changePasswordReturnUrl;
    let singlekeyIdUrl = environment.singleKeyIdToprofile;
    const url = `${singlekeyIdUrl}/auth/delete-account?clientId=${client_id}&changeType=mobile&returnUrl=${redirect_uri}`
    window.open(url, '_blank');
  }
}
